import React, { PropTypes } from "react";
import Component from "react-pure-render/component";
import { findDOMNode } from "react-dom";
import { DragSource, DropTarget } from "react-dnd";
import DragLayer from "../components/dragLayer.react";
import InputCustom from "../components/inputCustom.react";
import Modal from "../components/modal.react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";

const itemSource = {
  beginDrag(props) {
    const { setDraggingItemUID } = props;
    setDraggingItemUID(props.itemUID);
    return {
      itemUID: props.itemUID
    };
  },
  endDrag(props, monitor, component) {
    const { setDraggingItemUID, setHoveringItemUID, dropAction } = props;
    if (dropAction) {
      dropAction();
    }
    setDraggingItemUID("");
    setHoveringItemUID("");
  }
};

const itemTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().itemUID;
    const hoverIndex = props.itemUID;

    if (dragIndex === hoverIndex) {
      return;
    }

    const { setHoveringItemUID, hoveringItemUID } = props;
    setHoveringItemUID(hoverIndex);

    if (hoverIndex === hoveringItemUID) {
      return;
    }

    const { moveAction, moveActionProps } = props;
    if (moveAction) {
      moveAction(dragIndex, hoverIndex, moveActionProps);
    }
  }
};

function getTypes(props) {
  return props.types;
}

class FieldDragAndDrop extends Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    itemUID: PropTypes.string.isRequired,
    types: PropTypes.string.isRequired,
    setDraggingItemUID: PropTypes.func.isRequired,
    draggingItemUID: PropTypes.string.isRequired,
    setHoveringItemUID: PropTypes.func.isRequired,
    hoveringItemUID: PropTypes.string.isRequired,
    moveAction: PropTypes.func,
    moveActionProps: PropTypes.object,
    dropAction: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.wrapperWidth = 0;
    this.getElementWrapperWidth = this.getElementWrapperWidth.bind(this);
  }

  componentDidMount() {
    this.getElementWrapperWidth();
    window.addEventListener("resize", this.getElementWrapperWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.getElementWrapperWidth);
  }

  getElementWrapperWidth = () => {
    const { elementWrapper } = this.refs;
    this.wrapperWidth = findDOMNode(
      elementWrapper
    ).getBoundingClientRect().width;
  };

  renderLayer = () => {
    const { itemUID, draggingItemUID, field, actions } = this.props;
    const inputCustomProps = {
      feature: "fields",
      actions: actions,
      entity: field,
      uid: field.get("uid"),
      placeholder: ""
    };
    if (itemUID === draggingItemUID) {
      return (
        <DragLayer wrapperWidth={this.wrapperWidth}>
          <div className="col-xs-12">
            <div className="box-wrapper">
              <div className="title">
                <div className="row middle-xs">
                  <div className="col-xs-6">{field.get("name")}</div>
                  <div className="col-xs-6">
                    <button className="error">usuń pole</button>
                  </div>
                </div>
              </div>
              <div className="content-wrapper">
                <div className="row middle-xs">
                  <label className="col-xs-4">Typ pola</label>
                  <div className="col-xs-8">
                    <InputCustom {...inputCustomProps} field={["fieldType"]} />
                  </div>
                </div>
                <div className="row middle-xs">
                  <label className="col-xs-4">Nazwa pola</label>
                  <div className="col-xs-8">
                    <InputCustom {...inputCustomProps} field={["name"]} />
                  </div>
                </div>
                <div className="row middle-xs">
                  <label className="col-xs-4">Placeholder</label>
                  <div className="col-xs-8">
                    <InputCustom
                      {...inputCustomProps}
                      field={["placeholder"]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DragLayer>
      );
    }
  };

  removeField = () => {
    const {
      field,
      actions,
      notificationSystem,
      afterServerActionSuccess,
      uid
    } = this.props;
    actions.removeField(field.get("uid")).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        afterServerActionSuccess(uid);
      }
    });
    actions.setIsRemoveFieldModalVisible(false);
  };

  openRemoveFieldModal = () => {
    const { actions, field } = this.props;
    actions.setIsRemoveFieldModalVisible(field.get("uid"));
  };

  closeRemoveFieldModal = () => {
    const { actions } = this.props;
    actions.setIsRemoveFieldModalVisible(false);
  };

  render() {
    const {
      draggingItemUID,
      itemUID,
      connectDragSource,
      connectDropTarget,
      field,
      actions,
      isRemoveModalVisible
    } = this.props;
    const opacity = itemUID === draggingItemUID ? 0 : 1;
    const width = "100%";
    const inputCustomProps = {
      feature: "fields",
      actions: actions,
      entity: field,
      uid: field.get("uid"),
      placeholder: ""
    };

    return connectDropTarget(
      <div style={{ width }}>
        <div style={{ opacity, width }} ref="elementWrapper">
          <div className="col-xs-12">
            <div className="box-wrapper">
              {connectDragSource(
                <div className="title">
                  <div className="row middle-xs">
                    <div className="col-xs-6">{field.get("name")}</div>
                    <div className="col-xs-6">
                      <button
                        className="error"
                        onClick={this.openRemoveFieldModal}
                      >
                        usuń pole
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div className="content-wrapper">
                <div className="row middle-xs">
                  <label className="col-xs-4">Typ pola</label>
                  <div className="col-xs-8">
                    <InputCustom {...inputCustomProps} field={["fieldType"]} />
                  </div>
                </div>
                <div className="row middle-xs">
                  <label className="col-xs-4">Nazwa pola</label>
                  <div className="col-xs-8">
                    <InputCustom {...inputCustomProps} field={["name"]} />
                  </div>
                </div>
                <div className="row middle-xs">
                  <label className="col-xs-4">Placeholder</label>
                  <div className="col-xs-8">
                    <InputCustom
                      {...inputCustomProps}
                      field={["placeholder"]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isRemoveModalVisible === field.get("uid") && (
          <Modal
            closeModalAction={this.closeRemoveFieldModal}
            enterAction={this.removeField}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs middle-xs">
              <h3 className="col-xs-12">Potwierdź usunięcie</h3>
              <p>Czy napewno usunąć?</p>
              <div className="col-xs-12">
                <button className="error" onClick={this.removeField}>
                  Usuń
                </button>
                <button className="info" onClick={this.closeRemoveFieldModal}>
                  Anuluj
                </button>
              </div>
            </div>
          </Modal>
        )}
        {this.renderLayer()}
      </div>
    );
  }
}
export default DropTarget(getTypes, itemTarget, connect => ({
  connectDropTarget: connect.dropTarget()
}))(
  DragSource(getTypes, itemSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }))(FieldDragAndDrop)
);



// WEBPACK FOOTER //
// ./src/browser/template/fieldDragAndDrop.react.js